rEvent.on('Listing.fetchedData', () => {
    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing').first().find('.c-listing-products__item').length);
    }
})

$(function() {
    $('.js-form-page-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function(form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });

    $('.js-form-lost-password').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });

    $('.js-account-wishlist-modal').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });

    // Submit over AJAX so creating an offer keeps the customer on the current page.
    $('.js-price-offer-create').validate({
        submitHandler: function(form) {
            const $submit = $(form).find('[type="submit"]');

            $submit.prop('disabled', true).addClass('is-loading');

            Form.ajaxPost(form, function(data) {
                if (data.status) {
                    window.location.reload();

                    return;
                }

                $submit.prop('disabled', false).removeClass('is-loading');
                Eshop.alert(data.message, { type: 'error' });
            }, 'json');
        }
    });

    $('.js-b2b-reg').validate({
        errorPlacement: function (error, element) {
            if (element.attr('type').match('checkbox')) {
                error.insertAfter(element.siblings('label'));
            } else {
                error.insertAfter(element);
            }
        },
        rules: {
            'customer_logins[0][password_repeat]': {
                equalTo: '#customer-customer-logins-0-password'
            },
            'customer_logins[0][password]': {
                minlength: 8
            },
            phone: {
                phone: true
            },
            post_code: {
                number: true
            },
            org_num: {
                number: true,
                rangelength: [7, 8]
            },
            tax_num: {
                digits: true,
                exactlength: 10
            }
        },
        submitHandler: function (form) {
            $(form).find('[type="submit"]').addClass('is-loading');

            Form.ajaxPost(form, function (data) {
                $(".js-reg-error").slideUp();

                var msg = data.message;

                if (!data.status) {
                    $(form).find('[type="submit"]').removeClass('is-loading');

                    $(".js-reg-error")
                        .html(msg)
                        .slideDown();

                    $(".js-reg-error").slideHere(100, 0);
                } else {
                    $(form).fadeOut(250, function () {
                        window.location.reload();
                    });

                    $(".js-reg-success")
                        .html(msg)
                        .slideDown();

                    $(".js-reg-success").slideHere(100, 0);
                }
            }, "json");
        }
    });

    $('.js-not-vat-payer').on('change', function () {
        const isChecked = $(this).is(':checked'),
            $vatNumInput = $('.js-vat-num-input');

        $vatNumInput.prop('required', !isChecked);
        $vatNumInput.parents('.c-form__item').first().toggleClass('is-required', !isChecked);
    });
});
